export const XLandsraadActionSvg = ({ width }: { width: number }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_219_440)">
        <path
          d="M7.5 0L13.6819 4.83688L11.3206 12.6631H3.6794L1.31813 4.83688L7.5 0Z"
          fill="url(#paint0_linear_219_440)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_219_440"
          x="0.318115"
          y="0"
          width="14.3638"
          height="14.6631"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.77 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_219_440"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_219_440"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_219_440"
          x1="7.5"
          y1="0"
          x2="7.5"
          y2="14"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#68C67C" />
          <stop offset="1" stopColor="#238E57" />
        </linearGradient>
      </defs>
    </svg>
  );
};
